import { type Size as IconSize } from '@atoms/BasicIcon/sizes';

export const sizes = ['xs', 's', 'm', 'l'] as const;
export type Size = (typeof sizes)[number];

export const iconSizes: Record<Size, IconSize> = {
    xs: '8',
    s: '14',
    m: '20',
    l: '40',
};

export const defaultSize = 'm' as const satisfies Size;

export const sizeDependandClasses = {
    xs: 'p-1 text-xs leading-4',
    s: 'py-1 px-[10px] text-xs leading-5',
    m: 'p-3 text-sm leading-6',
    l: 'p-4 text-base leading-7',
} as const satisfies Readonly<Record<string, string>>;

export const getSizeDependandClasses = (size: Size) => {
    return sizeDependandClasses[size] || sizeDependandClasses[defaultSize];
};

export function getValidationClass(isValid: boolean | null): string {
    return isValid === true
        ? 'border-primary'
        : isValid === false
          ? 'border-red-500'
          : 'border-input';
}
